import React from 'react';
import * as styles from './index.module.less';

interface IProps {
  text: string;
  className?: string;
  isKeepWord?: boolean;
}

const CmsKeepWord = ({ text, className = '', isKeepWord = true }: IProps) => {
  return (
    <div className={`${className} ${isKeepWord && styles.cms_keep_word}`} dangerouslySetInnerHTML={{ __html: text }} />
  );
};
export default CmsKeepWord;
